import type { UserDto } from "@/api/types";

export const canEditGroupChat = ({
  isMember,
  chatPermission,
}: {
  isMember: boolean;
  chatPermission: UserDto["chatPermission"];
}): boolean => {
  if (!isMember) {
    return false;
  }

  if (chatPermission === "sendOnly" || chatPermission === "disabled") {
    return false;
  }

  return true;
};
